import { EmbeddedAPI } from '@ps/web-spade-embedded-api';

export const embeddedAPI = new EmbeddedAPI();
